import { render, staticRenderFns } from "./MarketOrderTableVariantTitle.vue?vue&type=template&id=43fef96c&"
import script from "./MarketOrderTableVariantTitle.vue?vue&type=script&lang=js&"
export * from "./MarketOrderTableVariantTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports